export const visit = (vm, at) => {
vm(require("foundations-components/lang/sv.lyaml"));
at({ "sv": { "placeholder": "platsh\xE5llare" } });
};